<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { TagsInputInputProps } from 'reka-ui';
  import { TagsInputInput, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<TagsInputInputProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <TagsInputInput
    v-bind="forwardedProps"
    :class="cn('text-xs h-5 focus:outline-none flex-1 bg-transparent px-1', props.class)"
  />
</template>
